export const genericLabel = (str: string) => {
  return str
    .replace(/_{1,}/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/(\s{1,}|\b)(\w)/g, function (_m, space, letter) {
      return space + letter.toUpperCase()
    })
}
